export default function(organizationApikey) {
  const organizationAccountData = this.getState()[`organizationAccountData:${organizationApikey}`]
  if (organizationAccountData) return Promise.resolve()
  return this.takeAction('reloadOrganizationAccountData', organizationApikey)
}
